// Nodes Definitions

export const EMPHASIS_DEFINITIONS = { type: 'emphasis' };
export const HEADING_DEFINITIONS = { type: 'heading' };
export const IMAGE_DEFINITIONS = { type: 'image' };
export const IMAGE_CAPTION_DEFINITIONS = { type: 'image-caption' };
export const LIST_ITEM_DEFINITIONS = { type: 'list-item' };
export const ORDERED_LIST_DEFINITIONS = { type: 'ordered-list' };
export const PARAGRAPH_DEFINITIONS = { type: 'paragraph' };
export const QUOTE_DEFINITIONS = { type: 'quote' };
export const QUOTE_SOURCE_DEFINITIONS = { type: 'quote-source' };
export const QUOTE_TEXT_DEFINITIONS = { type: 'quote-text' };
export const SUMMARY_DEFINITIONS = { type: 'summary' };
export const UNORDERED_LIST_DEFINITIONS = { type: 'unordered-list' };
export const TITLE_DEFINITIONS = { type: 'title' };

// Marks Definitions

export const BOLD_DEFINITIONS = { type: 'bold' };
export const ITALIC_DEFINITIONS = { type: 'italic' };
export const LINK_DEFINITIONS = { type: 'link' };
export const MENTION_DEFINITIONS = { type: 'mention' };
